export default class BaseEnum {
  constructor(value, description) {
    this.value = value;
    this.description = description;
  }
}
